import { render, staticRenderFns } from "./Graphics.vue?vue&type=template&id=1989acc8&"
import script from "./Graphics.vue?vue&type=script&lang=js&"
export * from "./Graphics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports